/**
 * Mode toggle component for switching between static and dynamic modes
 */

import React from 'react';
import { Button } from '@/ui-components/ui/button';
import { Label } from '@/ui-components/ui/label';
import { Database, Type, ChevronDown } from 'lucide-react';

interface ModeToggleProps {
  /** Current mode */
  mode: 'static' | 'dynamic';
  /** Label text */
  label?: string;
  /** Whether field is required */
  required?: boolean;
  /** Mode change handler */
  onModeChange: (mode: 'static' | 'dynamic') => void;
}

/**
 * Toggle component for switching between static and dynamic content modes
 */
export const ModeToggle: React.FC<ModeToggleProps> = ({
  mode,
  label,
  required = false,
  onModeChange
}) => {
  const handleToggle = () => {
    onModeChange(mode === 'static' ? 'dynamic' : 'static');
  };

  return (
    <div className="flex items-center justify-between">
      <Label className="text-xs font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={handleToggle}
        className={`h-5 px-2 py-0.5 text-xs rounded-full border transition-all hover:scale-105 ${
          mode === 'dynamic'
            ? 'bg-blue-100 border-blue-300 text-blue-700 hover:bg-blue-200'
            : 'bg-gray-100 border-gray-300 text-gray-700 hover:bg-gray-200'
        }`}
      >
        <div className="flex items-center gap-1">
          {mode === 'dynamic' ? (
            <>
              <Database className="w-2.5 h-2.5" />
              <span>Dynamisch</span>
            </>
          ) : (
            <>
              <Type className="w-2.5 h-2.5" />
              <span>Statisch</span>
            </>
          )}
          <ChevronDown className="w-2.5 h-2.5 opacity-60" />
        </div>
      </Button>
    </div>
  );
};